import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThemeType } from "../../../redux/constants";
import {
    selectCurrentPage,
    updateCurrentPage,
} from "../../../redux/slices/currentPageSlice";
import { selectAllClassifications } from "../../../redux/slices/classificationsSlice";
import {
    selectAllP2pSettings,
    selectBaseUrl,
} from "../../../redux/slices/p2pSettingsSlice";
import {
    selectAllRegistration,
    updateRegistrationClassification,
    replaceRegistrationsOnRegistration,
} from "../../../redux/slices/registrationSlice";
import { selectSpecificFormSetting } from "../../../redux/slices/formSettingsSlice";
import { selectThemeSettings } from "../../../redux/slices/cmsSettingsSlice";
import { selectHasParentRegistration } from "../../../redux/slices/appSettingsSlice";
import { removeNewTeamFromTeams } from "../../../redux/slices/teamsSlice";
import ClassificationPage from "./ClassificationPage";

const ConnectedClassificationPage = () => {
    const dispatch = useDispatch();
    const currentPage = useSelector(selectCurrentPage);
    const classifications = useSelector(selectAllClassifications);
    const p2pSettings = useSelector(selectAllP2pSettings);
    const { classificationLabel = "Classifications", enableClassifications } =
        p2pSettings;
    const hasClassifications =
        enableClassifications && classifications.length > 0;
    const hasParentRegistration = useSelector(selectHasParentRegistration);
    // -------------------------------------------------------------------------
    // TODO: Consolidate settings if needed for Formik. It appears we
    // are not using the settings passed for this page.
    // -------------------------------------------------------------------------
    const settings = {};
    const registration = useSelector(selectAllRegistration);
    const { classification, registrations } = registration;
    const getSavedValues = () => {
        if (classification && Object.keys(classification).length) {
            return {
                ...classification,
            };
        }
        return {};
    };
    const savedValues = getSavedValues();
    const themeSettings = useSelector((state) =>
        selectThemeSettings(ThemeType.HEADER, state),
    );

    const {
        primaryRegProgressBar: {
            classificationStepLabel = "%ClassificationLabel%",
        },
    } = themeSettings;
    const title = useSelector((state) =>
        selectSpecificFormSetting(state, "title"),
    );

    // Check if classificationLabel is an empty string as this value is set to
    // "" by default
    const defaultStepLabel = "Classifications";
    const hasDefaultClassificationLabel = classificationLabel === "";
    const formattedClassificationLabel = hasDefaultClassificationLabel
        ? defaultStepLabel
        : classificationLabel;
    const formattedClassificationStepLabel = classificationStepLabel.replace(
        "%ClassificationLabel%",
        formattedClassificationLabel,
    );
    const documentTitle = `${title} | ${formattedClassificationStepLabel}`;

    const baseUrl = useSelector(selectBaseUrl);

    const classificationPageProps = {
        baseUrl,
        classifications,
        currentPage,
        dispatch,
        documentTitle,
        hasClassifications,
        hasParentRegistration,
        registrations,
        removeNewTeamFromTeams,
        replaceRegistrationsOnRegistration,
        savedValues,
        settings,
        updateRegistrationClassification,
        updateCurrentPage,
    };
    return <ClassificationPage {...classificationPageProps} />;
};

export default ConnectedClassificationPage;
